import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/r/[referralCode]/ReferralClient.tsx");
